module.exports = __webpack_public_path__ + "static/media/logo.5b5772f1.png";